import type { BlockSortOrder, BlockWithTitle } from './types';

export function sortBlocks<T extends BlockWithTitle>(blocks: T[], order: BlockSortOrder): T[] {
  const sorted = [...blocks];
  switch (order) {
    case 'oldest':
      sorted.reverse();
      break;
    case 'alphabetical':
      sorted.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
      break;
    case 'random':
      for (let i = sorted.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [sorted[i], sorted[j]] = [sorted[j], sorted[i]];
      }
      break;
    case 'custom':
    case 'newest':
    default:
      break;
  }
  return sorted;
}
